const { ASYNC, SIMPLE } = require('../utils/redux-helpers');

module.exports = {
    CREATE: ASYNC,
    UPDATE: ASYNC,
    DELETE_SURVEY: ASYNC,
    STOP_SURVEY: ASYNC,
    START_SOLVING: ASYNC,
    SUBMIT_ANSWERS: ASYNC,
    GET_REPORT: ASYNC,
    INVITE: ASYNC,
    SET_SORT_TYPE: SIMPLE
};
